module.exports = __webpack_public_path__ + "static/media/success-white.a7b13767.svg";